import { Reveal } from "./Reveal";

export const PageHeader = ({ eyebrow, title, description }) => (
  <header className="border-b border-border px-5 pb-10 pt-28 sm:px-10 lg:px-16 lg:pb-14 lg:pt-36">
    <Reveal>
      {eyebrow && (
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal">
          {eyebrow}
        </p>
      )}
      <h1 className="mt-3 font-display text-4xl font-bold uppercase leading-[0.9] tracking-tighter sm:text-5xl lg:text-6xl">
        {title}
      </h1>
      {description && (
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          {description}
        </p>
      )}
    </Reveal>
  </header>
);
